import React, { Component } from 'react';
import {
  apiConsumtions,
  apiRepayments,
  apiRepaymentsDocument
} from '../../Api/Repayment/Repayment';
import { RemboursementTemplate } from './../../Templates/index';
import { connect } from 'react-redux';
import { COLOR_TABLE, REMBOURSEMENT_LIMIT, SERIES } from '../../Config/Config';
import * as moment from 'moment';
import getMemberTypeCode from '../../Utils/getMemberTypeCode';
import useHasContractFamily from '../../Utils/Functions';
class Remboursement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beginDate:
        this.props.location.state == null
          ? this.props.user.memberId
            ? new Date(
                parseInt(this.props.user.memberId.substring(0, 8), 16) * 1000
              )
            : new Date('01/01/2012')
          : this.props.location.state.beginDate, // modif
      endDate:
        this.props.location.state == null
          ? new Date()
          : this.props.location.state.endDate, // modif
      status:
        this.props.location.state == null
          ? 'remboursement'
          : this.props.location.state.status,
      carteTpCheck: false,
      selectData: {
        annual: [
          { text: 'Cette année', value: 'Cette année' },
          { text: 'L’année dernière', value: 'L’année dernière' }
        ],
        vision: [
          { text: 'Vision globale', value: 'Vision globale', index: 0 },
          { text: 'Par bénéficiaire', value: 'Par bénéficiaire', index: 2 },
          { text: 'Par poste', value: 'Par poste', index: 1 }
        ]
      },
      annual: 'Cette année',
      vision: 'Vision globale',
      seriesVisionGlobal: [],
      seriesBeneficiary: [],
      seriesPoste: [],
      remboursement: [],
      MessageRemboursement: '',
      skip: 0,
      limit: REMBOURSEMENT_LIMIT,
      consumtion: null,
      total: 0
    };
  }

  getRemboursementData = async (skip, limit, remboursement = []) => {
        const { data, status, total } = await apiRepayments(
          this.props.user?.memberNumber, // modif
          getMemberTypeCode(this.props.user?.memberType),
          moment(this.state.beginDate).format('MM/DD/YYYY'),
          moment(this.state.endDate).format('MM/DD/YYYY'),
          skip * limit,
          skip * limit + limit,
          this.state.carteTpCheck
        );
      if (status == 200) {
        this.setState(
          {
            remboursement: [...remboursement, ...data],
            skip: skip + 1,
            total: total
          },
          () => {
            if (this.state.remboursement.length == 0) {
              this.setState({
                MessageRemboursement: 'Aucun remboursement'
              });
            } else {
              this.setState({
                MessageRemboursement: ''
              });
            }
          }
        );
      } else {
        this.setState({
          MessageRemboursement: 'Aucun remboursement'
        });
      }
    
  };

  downloadRepaymentFile = async (
    skip,
    limit,
    fileNumber,
    remboursement = []
  ) => {
    if (this.state.beginDate != null && this.state.endDate != null) {
      const { fileName, pdf, status, total } = await apiRepaymentsDocument(
        this.props.user?.memberNumber, // modif
        getMemberTypeCode(this.props.user?.memberType),
        moment(this.state.beginDate).format('MM/DD/YYYY'),
        moment(this.state.endDate).format('MM/DD/YYYY'),
        skip * limit,
        skip * limit + limit,
        this.state.carteTpCheck,
        fileNumber
      );
      if (status == 200) {
        const binary = atob(pdf);
        const len = binary.length;
        const buffer = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          buffer[i] = binary.charCodeAt(i);
        }
        const blob = new Blob([buffer], { type: 'application/pdf' });

        // Create a link element and trigger the download
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'file.pdf'; // The name of the downloaded file
        link.click();

        // Clean up
        URL.revokeObjectURL(link.href);
        // const { blob, url } = await this.createBlob(pdf);
        // if (url) {
        //   const download = document.createElement('a');
        //   download.setAttribute('href', url);
        //   download.setAttribute('target', '_blank');
        //   download.click();
        // }
      }
    }
  };

  createBlob = async (data) => {
    try {
      const blob = await (
        await fetch(`data:application/pdf;base64,${data}`)
      ).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };

  getAllRemboursement = async (skip, limit) => {
    const { total, data, status } = await apiRepayments(
      this.props.user?.memberNumber, // modif
      getMemberTypeCode(this.props.user?.memberType),
      moment(this.state.beginDate).format('MM/DD/YYYY'),
      moment(this.state.endDate).format('MM/DD/YYYY'),
      skip * limit,
      skip * limit + limit,
      this.state.carteTpCheck
    );

    let restElement = 0;
    let nextData = [];
    let nextStatus = 400;
    if (total >= this.state.limit) {
      restElement = total - this.state.limit;
    }
    if (restElement != 0) {
      const { data, status } = await apiRepayments(
        this.props.user?.memberNumber, // modif
        getMemberTypeCode(this.props.user?.memberType),
        moment(this.state.beginDate).format('MM/DD/YYYY'),
        moment(this.state.endDate).format('MM/DD/YYYY'),
        limit,
        total,
        this.state.carteTpCheck
      );
      nextData = data;
      nextStatus = status;
    } else {
      nextStatus = 200;
    }
    if (status == 200 && nextStatus == 200) {
      this.setState(
        {
          remboursement: [...data, ...nextData],
          beginDate: null,
          endDate: null,
          skip: 0
        },
        () => {
          if (this.state.remboursement.length == 0) {
            this.setState({
              MessageRemboursement: 'Aucun remboursement'
            });
          } else {
            this.setState({
              MessageRemboursement: ''
            });
          }
        }
      );
    }
  };

  getConsumption = async (beginDate, endDate) => {
    const [resGlobal, resPost, resBenef] = await Promise.all(
      Array(3)
        .fill()
        .map((_, index) => {
          return apiConsumtions(
            this.props.user?.memberNumber, // modif
            index,
            moment(beginDate).format('MM/DD/YYYY'),
            moment(endDate).format('MM/DD/YYYY')
          );
        })
    );

    if (
      resGlobal.status == 200 &&
      resGlobal.codeRetour &&
      resBenef.status == 200 &&
      resPost.status === 200
    ) {
      const { codeRetour, postes, beneficiaires, status, ...restGlobal } =
        resGlobal;

      this.setState({
        seriesVisionGlobal: [
          {
            legend: 'Remboursement SPVIE',
            data: restGlobal.rbcgrm,
            color: COLOR_TABLE[0]
          },
          {
            legend: 'Sécurité sociale',
            data: restGlobal.rbss,
            color: COLOR_TABLE[1]
          },
          {
            legend: 'Reste à charge',
            data: restGlobal.rac,
            color: COLOR_TABLE[2]
          }
        ],
        seriesBeneficiary: resBenef.data.map((element, index) => {
          return {
            legend: `${element.nom} ${element.prenom}`,
            data: element.rac,
            color: COLOR_TABLE[index],
            ...element
          };
        }),
        seriesPoste: resPost.data.map((element, index) => {
          const { libPoste, ...rest } = element;
          return {
            serie: libPoste,
            data: [
              {
                legend: 'Remboursement SPVIE',
                data: rest.rbcgrm,
                color: COLOR_TABLE[0]
              },
              {
                legend: 'Sécurité sociale',
                data: rest.rbss,
                color: COLOR_TABLE[1]
              },
              {
                legend: 'Reste à charge',
                data: rest.rac,
                color: COLOR_TABLE[2]
              }
            ]
          };
        })
      });
    }
  };

  isValidFetch = () => {
    return (
      // this.state.beginDate &&
      this.props.user?.memberType && this.props.user?.memberNumber
    );
  };

  getDate = (fullYear) => {
    // modif
    // return {
    //   beginDate: `01/01/2012`,
    //   endDate: `12/31/2012`
    // };
    return {
      beginDate: `01/01/${fullYear}`,
      endDate: `12/31/${fullYear}`
    };
  };

  componentDidMount() {
    const { beginDate, endDate } = this.getDate(new Date().getFullYear());
       const isPProfileSante = useHasContractFamily("SANTE");
        if (isPProfileSante) {
    this.getConsumption(beginDate, endDate);
    if (this.isValidFetch()) {
      this.getRemboursementData(0, this.state.limit, this.state.remboursement);
    }
  }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.beginDate !== this.state.beginDate ||
        prevState.endDate !== this.state.endDate ||
        prevState.carteTpCheck !== this.state.carteTpCheck) &&
      this.isValidFetch()
    ) {
      this.getRemboursementData(0, this.state.limit, []);
    }
  }

  viewClicked = () => {
    this.setState({
      beginDate: this.props.user.memberId
        ? new Date(
            parseInt(this.props.user.memberId.substring(0, 8), 16) * 1000
          )
        : new Date('01/01/2012'),
      endDate: new Date()
    });
    // this.getAllRemboursement(0, this.state.limit);
  };

  datePickerChanged = (key, value) => {
    if (value && value[0] instanceof Date) {
      this.setState({
        [key]: new Date(value),
        remboursement: []
      });
    }
  };

  downloadDocument = (fileNumber) => {
    this.downloadRepaymentFile(0, this.state.limit, fileNumber);
  };

  statusChanged = (value) => {
    this.setState({
      status: value
    });

    if (value == 'remboursement') {
      this.props.history.push('/remboursement');
    } else {
      this.props.history.push('/consommation');
    }
  };

  selectFilterChange = (value, key) => {
    if (key == 'annual') {
      let beginDateFetch = '';
      let endDateFetch = '';
      if (value == 'Cette année') {
        const { beginDate, endDate } = this.getDate(new Date().getFullYear());
        beginDateFetch = beginDate;
        endDateFetch = endDate;
      } else {
        const { beginDate, endDate } = this.getDate(
          new Date().getFullYear() - 1
        );
        beginDateFetch = beginDate;
        endDateFetch = endDate;
      }

      this.getConsumption(beginDateFetch, endDateFetch);
    }

    this.setState({
      [key]: value
    });
  };

  carteTpChecked = (value) => {
    this.setState({
      carteTpCheck: value
    });
  };

  scroll = (e) => {
    const bottom =
      ~~e.target.scrollHeight -
        ~~e.target.scrollTop -
        ~~e.target.clientHeight <=
      1;
    if (
      bottom &&
      this.isValidFetch() &&
      this.state.total > this.state.remboursement.length
    ) {
      this.getRemboursementData(
        this.state.skip,
        this.state.limit,
        this.state.remboursement
      );
    }
  };

  render() {
    return (
      <RemboursementTemplate
        beginDate={this.state.beginDate}
        endDate={this.state.endDate}
        datePickerChanged={this.datePickerChanged}
        downloadDocument={this.downloadDocument}
        status={this.state.status}
        statusChanged={this.statusChanged}
        selectData={this.state.selectData}
        selectFilterChange={this.selectFilterChange}
        annual={this.state.annual}
        vision={this.state.vision}
        seriesVisionGlobal={this.state.seriesVisionGlobal}
        seriesBeneficiary={this.state.seriesBeneficiary}
        seriesPoste={this.state.seriesPoste}
        carteTpCheck={this.state.carteTpCheck}
        carteTpChecked={this.carteTpChecked}
        remboursement={this.state.remboursement}
        MessageRemboursement={this.state.MessageRemboursement}
        viewClicked={this.viewClicked}
        scroll={this.scroll}
      />
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  user: state.auth.user
});
export default connect(mapStateToProps, mapDispatchToProps)(Remboursement);
